import dayjs from 'dayjs'
import { filterUnderLine, getDateListByDateRange } from '@/utils'
import BaaS from 'minapp-sdk'

let SongOrderTable = new BaaS.TableObject('song_order')
let CommentTable = new BaaS.TableObject('comment')

export default {
  // 后台接口
  getOrderList: async (dateRange) => {
    let query = new BaaS.Query()
    const dateList = getDateListByDateRange(dateRange)
    const date = dateList || [dayjs().format('YYYY-MM-DD').toString()]
    query.in('date', date)
    query.compare('is_delete', '=', false)
    const res = await SongOrderTable.setQuery(query).limit(200).offset(0).find()
    // const res = await SongOrderTable.offset(0).limit(10).find()
    let list = []
    res.data.objects.forEach(v => {
      const item = filterUnderLine(v)
      const { id, songName, singerName, message, nickname, date, likeCount } = item
      list.push({ id, songName, singerName, message, nickname, date, likeCount })
    })
    return {
      code: 0,
      data: {
        list
      }
    }
  },
  deleteOrder: async (id) => {
    try {
      let record = SongOrderTable.getWithoutData(id)
      await record.set({
        is_delete: true
      }).update()
      return {
        code: 0,
        data: null
      }
    } catch (err) {
      return err
    }
  },
  // H5接口
  createOrder: async ({songName, singerName, nickname, message, date}) => {
    try {
      let record = SongOrderTable.create()
      await record.set({
        song_name: songName,
        singer_name: singerName,
        nickname: nickname,
        message: message,
        date: dayjs(date).format('YYYY-MM-DD').toString()
      }).save()
      return {
        code: 0,
        data: null
      }
    } catch (err) {
      return err
    }
  },
  getDailyList: async (d) => {
    let query = new BaaS.Query()
    const date = [d || dayjs().format('YYYY-MM-DD').toString()]
    query.in('date', date)
    query.compare('is_delete', '=', false)
    const res = await SongOrderTable.setQuery(query).find()
    // const res = await SongOrderTable.offset(0).limit(10).find()
    let list = []
    res.data.objects.forEach(v => {
      const item = filterUnderLine(v)
      const { id, songName, singerName, message, date, likeCount } = item
      list.push({ id, songName, singerName, message, date, likeCount })
    })
    return {
      code: 0,
      data: {
        list: list.slice(0, 3)
      }
    }
  },
  getMonthlyList: async (m) => {
    let query = new BaaS.Query()
    const date = m || dayjs().format('YYYY-MM').toString()
    query.contains('date', date)
    query.compare('is_delete', '=', false)
    const res = await SongOrderTable.setQuery(query).orderBy('-like_count').limit(10).offset(0).find()
    // const res = await SongOrderTable.offset(0).limit(10).find()
    let list = []
    res.data.objects.forEach(v => {
      const item = filterUnderLine(v)
      const { id, songName, singerName, message, date, likeCount } = item
      list.push({ id, songName, singerName, message, date, likeCount })
    })
    return {
      code: 0,
      data: {
        list
      }
    }
  },
  getOrderDetail: async (id) => {
    // let query = new BaaS.Query()
    // query.in('id', id)
    // const res = await SongOrderTable.setQuery(query).find()
    // let list = []
    // res.data.objects.forEach(v => {
    //   const item = filterUnderLine(v)
    //   const { id, songName, singerName, message, date, likeCount } = item
    //   list.push({ id, songName, singerName, message, date, likeCount })
    // })
    // let detail = list[0] || null
    const res = await SongOrderTable.get(id)
    const detail = filterUnderLine(res)
    return {
      code: 0,
      data: detail
    }
  },
  likeTheOrder: async ({id, cancel}) => {
    const res = await SongOrderTable.get(id)
    let { like_count: likeCount } = res.data
    try {
      let record = SongOrderTable.getWithoutData(id)
      if (cancel) {
        likeCount--
      } else {
        likeCount++
      }
      await record.set({
        like_count: likeCount
      }).update()
      return {
        code: 0,
        data: null
      }
    } catch (err) {
      return err
    }
  },
  getSongCommentList: async (id) => {
    try {
      let query = new BaaS.Query()
      query.compare('song', '=', SongOrderTable.getWithoutData('5dbdcd1d022b163e2c5b680a'))
      const res = await CommentTable.setQuery(query).expand(['song']).find()
      return {
        code: 0,
        data: {
          list: res.data.objects
        }
      }
    } catch (err) {
      return err
    }
  },
  logout: async () => {
    await BaaS.auth.logout()
  },
  login: async ({email, password}) => {
    await BaaS.auth.logout()
    try {
      const user = await BaaS.auth.login({
        email,
        password
      })
      return {
        code: 0,
        data: user.toJSON()
      }
    } catch (err) {
      return {
        code: err.status,
        data: err.data.error_msg
      }
    }
  },
  registry: async ({email, password}) => {
    try {
      const user = await BaaS.auth.register({
        email,
        password
      })
      return {
        code: 0,
        data: user.toJSON()
      }
    } catch (err) {
      return {
        code: err.status,
        data: err.data.error_msg
      }
    }
  },
  getCurrentUser: async () => {
    try {
      const user = await BaaS.auth.getCurrentUser()
      // const { avatar, is_admin: isAdmin, _email: email } = user.toJSON()
      return {
        code: 0,
        data: user.toJSON()
      }
    } catch (err) {
      if (err.code === 604) {
        // console.log('用户未登录')
        return {
          code: err.code,
          data: '用户未登录'
        }
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/api/index.js